import { useRef } from 'react';
import { Stack, Card }  from '@mui/material';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import PageSection from 'src/layouts/page-section';
import ListTable from './list-table';
import TitleButton from 'src/components/ui/headers/title-button';

const Page = ({ items}) => {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  
  return (
    <PageSection title="Tracking" rootRef={rootRef}>
      <Stack spacing={1}>
        <TitleButton label={t(tokens.nav.tracking)} />
        <Card>
          <ListTable items={items}  />
        </Card>
      </Stack>
    </PageSection>
  );
};

export default Page;
